import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext(null);

const darkTheme = {
  "--theme-accent": "#0081aa",
  "--theme-primary": "#111111",
  "--theme-primary-hover": "#1c1c1c",
  "--theme-secondary": "#242627",
  "--theme-secondary-hover": "#181818",
  "--theme-tertiary": "#0b0b0b",
  "--theme-error": "#352022",
  "--theme-error-input": "#f87171",
  "--theme-text": "#d3d3d3",
};

const lightTheme = {
  "--theme-accent": "#0081aa",
  "--theme-primary": "#fff",
  "--theme-primary-hover": "#dddddd",
  "--theme-secondary": "#e3e3e3",
  "--theme-secondary-hover": "#F0F0F0",
  "--theme-tertiary": "#f6f6f6",
  "--theme-error": "#352022",
  "--theme-error-input": "#f87171",
  "--theme-text": "#292929",
};

const DARK = "dark";
const LIGHT = "light";

export const ThemeContextProvider = ({ children }) => {
  // 'DARK', 'LIGHT'
  const [selectedTheme, setSelectedTheme] = useState(LIGHT);

  useEffect(() => {
    const isDARK =
      selectedTheme === DARK ||
      localStorage.theme === DARK ||
      (!("theme" in localStorage) && window.matchMedia(`(prefers-color-scheme: ${DARK})`).matches);

    isDARK ? changeTheme(DARK) : changeTheme(LIGHT);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function changeTheme(themeArg) {
    const theme = getTheme(themeArg);
    const themeObj = theme === LIGHT ? lightTheme : darkTheme;
    const root = document.documentElement;

    Object.entries(themeObj).forEach(([key, value]) => root.style.setProperty(key, value));

    setSelectedTheme(theme);
    localStorage.theme = theme;
  }

  function getTheme(theme) {
    // If theme is provided, return theme
    if (theme) {
      return theme;
    }

    // if no theme is provided, toggle between dark and light
    return selectedTheme === LIGHT ? DARK : LIGHT;
  }

  const value = {
    changeTheme,
    DARK,
    LIGHT,
    selectedTheme,
  };

  return <ThemeContext.Provider value={value}> {children} </ThemeContext.Provider>;
};

export default ThemeContext;
